import { render, staticRenderFns } from "./ShowLogo.vue?vue&type=template&id=e6828c20&"
import script from "./ShowLogo.vue?vue&type=script&lang=js&"
export * from "./ShowLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports